import { Widget } from "@foretagsplatsen/widgetjs";
import CheckboxWidget from "./CheckboxWidget/CheckboxWidget.js";
import TreeWidget from "./tree/TreeWidget/TreeWidget.js";

/**
 * `accountGroupRowExclusionWidget` is a widget displaying the list of
 * excluded groups of an account group row template. The widget
 * allows adding and removing account groups from the list.
 *
 * @param {ExclusionGroupSet} spec.exclusionGroupSet - This object is responsible
 * for checking existence, adding and removing account groups.
 */
export default class AccountGroupRowExclusionWidget extends Widget {
	constructor({ exclusionGroupSet }) {
		super(...arguments);

		this._exclusionGroupSet = exclusionGroupSet;
	}

	renderContentOn(html) {
		this._tree = new TreeWidget({
			getId: (item) => item.getId(),
			data: this._exclusionGroupSet.getTopLevelAccountGroups(),
			getLabel: (item) => this._accountGroupRenderer(item),
			getChildren: (item) =>
				this._exclusionGroupSet.getAccountGroupChildren(item),
			canBeSelected: () => false,
			autoOpen: 0,
			cssClass: "setting-section",
		});

		html.div(this._tree);
	}

	_accountGroupRenderer(accountGroup) {
		return new CheckboxWidget({
			toggleCallback: (checked) =>
				this._setExclusionOfAccountGroup({ accountGroup, checked }),
			checked: !this._exclusionGroupSet.isExcluded(accountGroup),
			label: accountGroup.getName(),
			dataTestName: "exclusion-checkbox",
		});
	}

	_setExclusionOfAccountGroup({ accountGroup, checked }) {
		this._exclusionGroupSet.setExclusionOfAccountGroup({
			accountGroup,
			exclude: !checked,
		});

		this._tree.updateChildren();
		this._tree.scrollTo(accountGroup);
	}
}
